export function filterProperReleases(versions) {
    if (!versions) {
        return [];
    }
    return versions
        ? (versions || []).filter((v) => { var _a; return (_a = v.version) === null || _a === void 0 ? void 0 : _a.match(/^[0-9.]+$/); })
        : [];
}
